// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ow-z","tooltipWrapper":"pw-z","icon":"qw-z","tooltip":"rw-z","content":"sw-z"};